import { Typography } from '@mui/material';
import StepComponent from '../components/step.component';
import formSchema from '../../device-details-component/formSchema.json';
import { get } from 'lodash';
import { STEP_IDS } from './index';
import { isTariffCountryNameValid } from '../../shared/device-details-utils';

function getTariffCountryName(configurationData, changes) {
  const energyTariffChanges = changes.get(STEP_IDS.ENERGY_TARIFF, configurationData.ENERGY_TARIFF)?.countryStructure;
  return energyTariffChanges?.countryName;
}

function isCountryStructurePartOfSchema(configurationData) {
  return configurationData.schemas.properties.countryStructure !== undefined;
}

export default {
  title: 'Address',
  description: 'Address details of the installation site.',
  helperText: {
    header: (
      <>
        <Typography variant="h6">Enter the full installation address of the FlexiObox.</Typography>
        <Typography
          variant="body"
          fontWeight={500}
        >
          ℹ️ This is necessary for running FlexiO fluently (eg. weather prediction, DSO,...)
        </Typography>
      </>
    ),
  },
  component: StepComponent,
  schema: formSchema.properties.address || formSchema.properties.addressObj,
  diffFunction: (diffObj) => get(diffObj, 'configuration.address', false),

  validateFunction: (_schema, formData, allWizardFormData, changes) => {
    if (!formData) {
      return true;
    }

    if (isCountryStructurePartOfSchema(allWizardFormData)) {
      const tariffCountryName = getTariffCountryName(allWizardFormData, changes);
      return isTariffCountryNameValid(formData.country, tariffCountryName);
    }

    return true;
  },
  customValidator: (formData, errors, _uiSchema, configurationData, changes) => {
    if (isCountryStructurePartOfSchema(configurationData)) {
      const configuredTariffCountryName = getTariffCountryName(configurationData, changes);

      if (!isTariffCountryNameValid(formData.country, configuredTariffCountryName)) {
        errors.country.addError('The tariff country must match the configured country name or be set to CUSTOM');
      }
    }

    return errors;
  },
  uiSchema: {
    'ui:options': {
      title: false,
      classNames: 'address-container dense',
    },
  },
};
